<template>
  <div class="feedback">
    <div class="yjfk">意见反馈</div>
    <div class="back-input">
      <div class="back-title"><span>*</span>反馈标题</div>
      <input type="text" v-model="backData.title" placeholder="请输入反馈标题" maxlength="100" />
    </div>
    <div class="back-input">
      <div class="back-title"><span>*</span>联系方式</div>
      <input type="number" v-model="backData.phoneNum" placeholder="请输入电话号码" maxlength="100" />
    </div>
    <div class="back-input">
      <quill-editor
        v-model="backData.content"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
      >
      </quill-editor>
    </div>
    <div style="text-align: center">
      <el-button class="submit" v-if="showSub" type="primary" @click="submit">提交</el-button>
      <el-button class="submit" v-else type="primary" disabled>提交</el-button>
    </div>
    
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  name: "feedback",
  components: {
    quillEditor,
  },
  data() {
    return {
      backData: {
        title: "",
        content: "",
        phoneNum: "",
        source: this.$route.query.type,
      },
      showSub: true,
      content: "",
      editorOption: {
        placeholder: "请输入内容",
        modules: {
          toolbar: [
            ["bold", "italic"], //加粗，斜体，下划线，删除线
            ["image"], //上传图片、上传视频
          ],
        },
      },
    };
  },
  methods: {
    submit() {
      if (this.backData.title == '') {
        this.$message.error('请输入标题')
        return false
      }
      if (this.backData.phoneNum == '') {
        this.$message.error('请输入联系方式')
        return false
      }
      if (this.backData.content == '') {
        this.$message.error('请输入内容')
        return false
      }
      let url = '/v1/cloud/common/feedBack/save'
      this.$axios.post(url ,this.backData).then(({data})=>{
        if(data) {
          this.$message.success('提交成功')
          this.showSub = false
        }
      }).catch(error=>{
        if(error.response.status == 400){
            this.$Message.error(error.response.data.message);
        }else if(error.response.status == 401){
            this.$router.push({name:'login'})
        }  
      })
    }
  },
  created() {},
  mounted() {},
};
</script>

<style lang="less">
.feedback {
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
  position: fixed;
  .back-title span {
    color: red;
  }
  .submit {
    margin: 20px auto;
  }
  .yjfk {
    
    width: 80%;
    font-weight: 500;
    font-size: 22px;
    line-height: 34px;
    color: #000;
    margin: 20px auto;
    padding-left: 5px;
  }
  .quill-editor {
    width: 100%;
  }
  .ql-toolbar {
    border: none;
  }
  .ql-container {
    max-height: 200px;
    overflow: auto;
  }
  .quill-editor .ql-snow {
    border: none;
  }
  .ql-editor {
    border-top: 1px solid #ccc;
    min-height: 200px;
  }
  .back-input {
    width: 80%;
    margin: 0 auto;
    padding: 20px 10px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    margin-top: 30px;
  }
  .back-title {
    color: #000;
    margin: 0 20px;
  }
  .back-input input {
    border: none;
    flex: 1;
    outline: none;
  }
  @media only screen and (max-width: 1200px) {
    .back-input {
      width: 100%;
    }
    .yjfk {
      width: 100%;
    }
  }
}
</style>
